import DropZone from './dropzone';

export default DropZone;
